import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    allNotification: [],
    count: 0
  },
  reducers: {
    setAllNotification: (state, action) => {
      state.allNotification = [...state.allNotification, action.payload];
    },
    setCount: (state, action) => {
      state.count = state.count + action.payload;
    },
    resetCount: (state) => {
      state.count = 0
    },
    resetNotification: (state) => {
      state.allNotification = []
    },
    newCount: (state, action) => {
      state.count = action.payload
    },
    newNotification: (state, action) => {
      state.allNotification = action.payload
    }

  },
});

export const { setAllNotification, setCount, resetCount, resetNotification, newCount, newNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
